import { Injectable } from '@angular/core';
import type { HelpdeskTaskFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-task-find.dto';
import { HelpdeskTaskTemplateAllQueryInterface } from '@zaoblako/shared/modules/helpdesk/dto/template/helpdesk.task.template.all.query.dto';
import type { HelpdeskTaskTemplateFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/template/helpdesk-task-template-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelpDeskTaskTemplateService extends BaseService {
  protected baseUrl = '/helpdesk/task-template';

  public findAll(queryParams?: HelpdeskTaskTemplateAllQueryInterface): Observable<HelpdeskTaskTemplateFindInterface[]> {
    return this.http.get<HelpdeskTaskTemplateFindInterface[]>(`${this.baseUrl}/all`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public clone(templateId: number): Observable<HelpdeskTaskTemplateFindInterface> {
    return this.http.get<HelpdeskTaskTemplateFindInterface>(`${this.baseUrl}/${templateId}/clone`);
  }

  public getCreatedTasksWidget(templateId: number): Observable<HelpdeskTaskFindInterface[]> {
    return this.http.get<HelpdeskTaskFindInterface[]>(`${this.baseUrl}/${templateId}/created-tasks`);
  }
}
